import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class LanguageService {

  public languages: string[] = ['ar', 'en'];

  constructor(public translate: TranslateService, private cookieService: CookieService) {

    let browserLang: any;
    /***
     * cookie Language Get
    */
    this.translate.addLangs(this.languages);
    if (localStorage.getItem('lang')) {
      browserLang = localStorage.getItem('lang');
    }
    else {
      browserLang = translate.getBrowserLang();
    }
    translate.use(browserLang.match(/en|ar/) ? browserLang : 'ar');
  }

  /***
   * Cookie Language set
   */
  public setLanguage(lang: any) {
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
  }


  toggleRtl(isRtl: boolean): void {
    window.location.reload();
    const head = document.getElementsByTagName('head')[0];
    let rtlStyleLink = document.getElementById('rtl-style') as HTMLLinkElement;
  
    if (isRtl) {
      document.documentElement.setAttribute('dir', 'rtl');
      if (!rtlStyleLink) {
        rtlStyleLink = document.createElement('link');
        rtlStyleLink.id = 'rtl-style';
        rtlStyleLink.rel = 'stylesheet';
        rtlStyleLink.href = 'styles.rtl.css'; // Link to the compiled CSS file
        head.appendChild(rtlStyleLink);
      }
    } else {
      if (rtlStyleLink) {
        head.removeChild(rtlStyleLink);
        document.documentElement.setAttribute('dir', 'ltr');
      }
    }

  }
}
